// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"seller-badges_ko-KR__suPXj","impressionTrackingContainer":"seller-badges_impressionTrackingContainer__e9Bv5","sellerBadge":"seller-badges_sellerBadge__pbfwG"};